class BannerMediaControls extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', this.handleClick);
    this.banner = this.closest('.hero__container, .slideshow-section');
    this.banner?.addEventListener('play', this.syncState, true);
    this.banner?.addEventListener('pause', this.syncState, true);

    this.observer = new MutationObserver(this.syncState);
    const slideshow = this.banner?.querySelector('slideshow-component');
    if (slideshow) {
      this.observer.observe(slideshow, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-hidden'],
      });
    }

    this.syncState();
    requestAnimationFrame(this.syncState);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.banner?.removeEventListener('play', this.syncState, true);
    this.banner?.removeEventListener('pause', this.syncState, true);
    this.observer?.disconnect();
  }

  get activeVideos() {
    if (!this.banner) return [];

    return [...this.banner.querySelectorAll('video')].filter((video) => {
      const slide = video.closest('slideshow-slide');
       if (slide) return slide.getAttribute('aria-hidden') !== 'true';

      const mediaWrapper = video.closest('.hero__media-wrapper');
      return !mediaWrapper || getComputedStyle(mediaWrapper).display !== 'none';
    });
  }

  handleClick = () => {
    const videos = this.activeVideos;
    const shouldPause = videos.some((video) => !video.paused && !video.ended);

    for (const video of videos) {
      if (shouldPause) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
    }

    this.syncState();
  };

  syncState = () => {
    if (!this.button) return;

    const videos = this.activeVideos;
    this.hidden = videos.length === 0;
    const isPlaying = videos.some((video) => !video.paused && !video.ended);
    this.toggleAttribute('playing', isPlaying);
    this.button.setAttribute(
      'aria-label',
      isPlaying ? this.button.dataset.pauseLabel : this.button.dataset.playLabel
    );
  };
}

class BannerScrollControl extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = () => {
    const section = this.closest('.shopify-section') || this.closest('section');
    const nextSection = section?.nextElementSibling;
    nextSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
}

if (!customElements.get('banner-media-controls')) {
  customElements.define('banner-media-controls', BannerMediaControls);
}

if (!customElements.get('banner-scroll-control')) {
  customElements.define('banner-scroll-control', BannerScrollControl);
}